import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { MdOutlineDelete } from "react-icons/md";

function DeleteVersionModal({ isModalOpen, setIsModalOpen, versionToDelete, onConfirmDelete, isDeleting }) {
    const handleClose = () => {
        setIsModalOpen(false);
    };

    const handleConfirm = () => {
        if (versionToDelete && onConfirmDelete) {
            onConfirmDelete({ id: versionToDelete?.id });
        }
    };
    return (
        <Modal isOpen={isModalOpen} toggle={handleClose} centered>
            <ModalHeader toggle={handleClose} className="modal-colored-header bg-danger">
                <div className="d-flex align-items-center">
                    <MdOutlineDelete style={{ fontSize: '24px', marginRight: '10px', color: 'white' }} />
                    <span style={{ color: 'white' }}>Delete Version</span>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="text-center">
                    <MdOutlineDelete style={{ fontSize: '48px', color: '#dc3545', marginBottom: '15px' }} />
                    <h5 className="mb-3">Are you sure you want to delete this version?</h5>
                    {versionToDelete?.version && (
                        <div className="alert alert-warning ">
                            <strong>Version:</strong> {versionToDelete.version}
                            <strong className='ml-2'>Title:</strong> {versionToDelete.title}
                        </div>
                    )}
                    <p className="text-muted mb-0">
                        This action cannot be undone. The version will be permanently deleted.
                    </p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleClose} disabled={isDeleting}>
                    Cancel
                </Button>
                <Button 
                    color="danger" 
                    onClick={handleConfirm}
                    disabled={isDeleting}
                >
                    {isDeleting ? 'Deleting...' : 'Delete Version'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteVersionModal;

